const Video = ({ color }: any) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.3337 4.66602L10.667 7.99935L15.3337 11.3327V4.66602Z'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.33366 3.33398H2.00033C1.26395 3.33398 0.666992 3.93094 0.666992 4.66732V11.334C0.666992 12.0704 1.26395 12.6673 2.00033 12.6673H9.33366C10.07 12.6673 10.667 12.0704 10.667 11.334V4.66732C10.667 3.93094 10.07 3.33398 9.33366 3.33398Z'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Video
